// extracted by mini-css-extract-plugin
module.exports = {"container":"Overlay_container__3K3QP","close":"Overlay_close__gNi5S","close__link":"Overlay_close__link__QxAbr"};